<template>
  <el-row v-loading="mainLoading">
    <el-col>
      <span
        v-if="dot"
        style="position: fixed; top: 10px; right: 10px; border-radius: 5px; width: 10px; height: 10px; display: block; background: red;"
      ></span>
      <el-form ref="form" :model="form" label-width="200px" label-position="top" onsubmit="return false">
        <el-form-item>
          Age group
          <br />
          <el-button-group>
            <el-button size="mini" :type="selectedTags.indexOf(5) !== -1 ? 'primary' : ''" @click="clickTags(5)"
              >5</el-button
            >
            <el-button size="mini" :type="selectedTags.indexOf(1) !== -1 ? 'primary' : ''" @click="clickTags(1)"
              >1</el-button
            >
            <el-button size="mini" :type="selectedTags.indexOf(2) !== -1 ? 'primary' : ''" @click="clickTags(2)"
              >2</el-button
            >
            <el-button size="mini" :type="selectedTags.indexOf(3) !== -1 ? 'primary' : ''" @click="clickTags(3)"
              >3</el-button
            >
            <el-button size="mini" :type="selectedTags.indexOf(4) !== -1 ? 'primary' : ''" @click="clickTags(4)"
              >4</el-button
            >
          </el-button-group>
          <br />
          Other
          <br />
          <el-button-group>
            <el-button
              size="mini"
              :type="selectedTags.indexOf('lunch') !== -1 ? 'primary' : ''"
              @click="clickTags('lunch')"
              >Lunch</el-button
            >
            <el-button
              size="mini"
              :type="selectedTags.indexOf('extend') !== -1 ? 'primary' : ''"
              @click="clickTags('extend')"
              >Extended care</el-button
            >
            <el-button size="mini" :type="selectedTags.indexOf('pc') !== -1 ? 'primary' : ''" @click="clickTags('pc')"
              >PC</el-button
            >
          </el-button-group>
        </el-form-item>
        <el-form-item label="Search">
          <el-input type="text" v-model="search"></el-input>
        </el-form-item>
      </el-form>
    </el-col>
    <el-col>
      <ul class="list" style="list-style: none;">
        <li v-for="(item, index) of studentsShow" :key="index">
          <div class="user">
            <span class="name">
              <div>{{ item.name }}</div>
              <div>
                <span class="parent"><i class="el-icon-star-on" />{{ item.course }}</span>
                <span class="parent"><i class="el-icon-s-custom" /> {{ item.parent.join(',') }}</span>
              </div>
            </span>
            <!--            <span class="course"></span>-->
            <el-button
              v-if="now <= 12"
              :type="item.check === 'in' ? 'info' : 'success'"
              :disabled="item.check === 'in'"
              @click="check_in(item)"
              :loading="item.loading"
              >Check In</el-button
            >
            <el-button
              v-if="now > 12"
              :type="item.check === 'out' ? 'info' : item.check === 'in' ? 'primary' : 'success'"
              :disabled="item.check === 'out'"
              @click="check_out(item)"
              :loading="item.loading"
              >Check Out</el-button
            >
            <i
              @click="
                students.filter(s => s.name !== item.name).forEach(s => (s.show = false))
                item.show = !item.show
              "
              :class="{ icon: true, 'el-icon-caret-right': !item.show, 'el-icon-caret-bottom': item.show }"
            />
          </div>
          <div>
            <el-tag v-if="item.lunch" size="mini" type="success">LUNCH</el-tag>
            <el-tag v-if="item.extend" size="mini" type="warning">EXTEND</el-tag>
            <el-tag v-if="item.pc" size="mini" type="danger">PC</el-tag>
          </div>
          <div v-if="item.show" class="expand">
            <div class="bt">
              <!--              <el-input type="text" size="mini" v-model="item.comment" placeholder="Comments"></el-input>-->
              <!--              <el-button size="mini" :loading="item.loading">Add Comments</el-button>-->
              <div class="title">Parent Name:</div>
              <el-select
                v-model="item.parent"
                size="mini"
                multiple
                filterable
                allow-create
                default-first-option
                placeholder="Parent Name"
              >
                <el-option v-for="p in item.parents" :key="p" :label="p" :value="p"></el-option>
              </el-select>
              <div class="title">Comments:</div>
              <el-select
                v-model="item.commits"
                size="mini"
                multiple
                filterable
                allow-create
                default-first-option
                placeholder="Comments"
              >
                <el-option v-for="p in item.commits" :key="p" :label="p" :value="p"></el-option>
              </el-select>
              <div class="title">PS: It is valid to modify before Check-In or Check-Out!</div>
            </div>
            <div class="bt">
              <el-button
                v-if="item.check === '' && now > 12"
                size="mini"
                type="danger"
                :loading="item.loading"
                @click="check_in(item)"
                >Check-In</el-button
              >
              <el-button
                v-if="item.check === 'in'"
                size="mini"
                type="danger"
                :loading="item.loading"
                @click="cancel_check(item)"
                >Cancel Check-In</el-button
              >
              <el-button
                v-if="item.check === 'in' && now <= 12"
                size="mini"
                type="danger"
                :loading="item.loading"
                @click="check_out(item)"
                >Check-Out</el-button
              >
              <el-button
                v-if="item.check === 'out'"
                size="mini"
                type="danger"
                :loading="item.loading"
                @click="cancel_check(item)"
                >Cancel Check-Out</el-button
              >
            </div>
          </div>
        </li>
      </ul>
    </el-col>
  </el-row>
</template>

<script>
// const {or, and, gt, lt} = require('sequelize').Op;
import moment from 'moment'

export default {
  name: 'Min',
  title: 'HOME phone',
  data: function() {
    return {
      now: new Date().getHours(),
      timer: 0,
      search: '',
      dot: false,
      mainLoading: true,
      medicalLoading: false,
      loading: false,
      check: 'check_in',
      // socket: io('http://localhost:2019'),
      form: {
        name: '',
        parent: [],
        code: '',
        course: '',
        teacher: this.$store.state.user.info.name,
        temperature: ''
      },
      student: [],
      studentOut: [],
      students: [],
      studentsShow: [],
      parents: [],
      extend: {},
      checkLoading: {
        in: false,
        out: false
      },
      keys: [
        ['1', '2', '3'],
        ['4', '5', '6'],
        ['7', '8', '9'],
        ['0', '.', 'Delete']
      ],
      selectedTags: []
    }
  },
  watch: {
    search(v, o) {
      this.handleSearch()
    },
    check() {
      this.form = {
        name: '',
        parent: [],
        code: '',
        course: '',
        teacher: this.$store.state.user.info.name,
        temperature: ''
      }
    },
    'form.name'(val) {
      // console.log(`form.name`, val, this.form, this.extend)
      if (val === '') return false
      let parents = this.students
        .filter(s => {
          return s.name === val
        })
        .map(s => s.parents)[0]
        .map(p => {
          return { label: p, value: p }
        })
      this.extend = this.students.filter(s => {
        return s.name === val
      })[0]
      // console.log(this.extend)
      this.form.course = this.students.filter(s => {
        return s.name === val
      })[0].course
      this.parents = parents
      this.form.parent = [parents[0].value]
      if (this.check === 'check_out')
        this.$socket.emit('getCode', val, code => {
          this.form.code = code
        })
    },
    selectedTags(val) {
      this.handleSearch()
    }
  },
  computed: {
    courses() {
      if (this.$store.state.user.info) {
        return this.$store.state.user.info.courses.map(c => {
          return { label: c, value: c }
        })
      } else {
        return null
      }
    }
  },
  mounted: function() {
    // eslint-disable-next-line
    console.log(navigator)

    if (/windows/gi.test(navigator.userAgent)) return this.$router.push('/home')

    let courses = this.$store.state.user.info.courses

    let where = {
      $or: courses.map(c => {
        if (/%/g.test(c)) {
          return { course: { $like: c } }
        } else {
          return { course: c }
        }
      })
    }
    // eslint-disable-next-line
    // console.log(where)
    this.$socket.emit('get_users', where, (err, us) => {
      this.$socket.emit('get_users_log', us, (err, uss) => {
        // eslint-disable-next-line
        console.log(uss)
        this.students = uss.map(u => {
          console.log(`u ->`, u)
          u.show = false
          u.loading = false
          if (!u.parent) u.parent = [u.parents[u.parents.length - 1]]
          if (!u.check) u.check = ''
          if (!u.commits) u.commits = []
          return u
        })
        this.student = this.students
          .filter(u => !u.check)
          .map(u => u.name)
          .map(item => {
            return { value: item, label: item }
          })
          .sort(this.nameSort)
        this.studentOut = this.students
          .filter(u => u.check && u.check === 'in')
          .map(u => u.name)
          .map(item => {
            return { value: item, label: item }
          })
          .sort(this.nameSort)
        // eslint-disable-next-line
        // console.log(this.student, this.studentOut)
        this.studentsShow = this.students.sort((a, b) => {
          let aa = a.name.substring(0, 1).charCodeAt(),
            bb = b.name.substring(0, 1).charCodeAt()
          // if (a.check === 'in' && now <= 12) aa = 1
          // if (a.check === 'out' && now > 12) aa = 1
          // if (b.check === 'in' && now <= 12) bb = 1
          // if (b.check === 'out' && now > 12) bb = 1
          return aa - bb
        })
        this.mainLoading = false
      })
    })

    // this.$socket.on('connect', () => {
    //   // eslint-disable-next-line
    //   console.log('connect...')
    // })

    // this.$socket.on('connected', () => {
    //   // eslint-disable-next-line
    //   console.log('connected!')
    // })
    //
    this.sockets.listener.subscribe('notice', data => {
      // eslint-disable-next-line
      console.log(
        `notice`,
        data,
        this.courses.filter(c => c === data.course)
      )
      if (this.courses.filter(c => new RegExp(c.value.replace('%', '.*'), 'i').test(data.course)).length > 0) {
        switch (data.type) {
          case 'notice':
            this.$notify({
              title: data.title,
              message: data.message,
              duration: data.duration || 0,
              position: 'top-left'
            })
            break

          case 'message':
            this.$message.info({
              type: 'info',
              message: `[${data.message}] ${data.title}`,
              duration: data.duration || 0,
              showClose: data.duration || data.duration === 0
            })
            break

          case 'dot':
            this.dot = true
            if (data.duration && data.duration > 0) {
              setTimeout(() => {
                this.dot = false
              }, data.duration)
            }
            break
        }

        // this.$message.info(data.title)
      }
    })
    // console.log(this)

    this.timer = setInterval(() => {
      let t = new Date().getHours()
      console.log(t)
      this.now = t
    }, 1000)
  },
  // sockets: {
  //   connect: function() {
  //     // eslint-disable-next-line
  //     console.log('connected!')
  //   },
  //   notice: function(data) {
  //     // eslint-disable-next-line
  //     console.log(`notice`, data, this.form)
  //     if (data.course === this.form.course) {
  //       switch (data.type) {
  //         case 'notice':
  //           this.$notify({
  //             title: data.title,
  //             message: data.message,
  //             duration: data.duration || 0,
  //             position: 'top-left'
  //           })
  //           break
  //
  //         case 'message':
  //           this.$message.info({
  //             type: 'info',
  //             message: `[${data.message}] ${data.title}`,
  //             duration: data.duration || 0,
  //             showClose: data.duration || data.duration === 0
  //           })
  //           break
  //
  //         case 'dot':
  //           this.dot = true
  //           if (data.duration && data.duration > 0) {
  //             setTimeout(() => {
  //               this.dot = false
  //             }, data.duration)
  //           }
  //           break
  //       }
  //
  //       this.$message.info(data.title)
  //     }
  //   }
  // },
  methods: {
    handleKeyboardClick(key, val) {
      this.form.temperature = val
    },
    nameSort(a, b) {
      let _a = a.value
          .toLocaleLowerCase()
          .split(' ')
          .map(i => i.charCodeAt(0)),
        _b = b.value
          .toLocaleLowerCase()
          .split(' ')
          .map(i => i.charCodeAt(0))
      for (let k in _a) {
        if (_a[k] !== _b[k]) {
          if (!_a[k]) _a[k] = 0
          if (!_b[k]) _b[k] = 0
          // console.log(_a[k] - _b[k], _a[k], _b[k])
          return _a[k] - _b[k]
        }
      }
      return -1
    },
    updateStudent() {
      this.student = this.students
        .filter(u => !u.check)
        .map(u => u.name)
        .map(item => {
          return { value: item, label: item }
        })
        .sort(this.nameSort)
      this.studentOut = this.students
        .filter(u => u.check && u.check === 'in')
        .map(u => u.name)
        .map(item => {
          return { value: item, label: item }
        })
        .sort(this.nameSort)
    },
    medical() {
      this.medicalLoading = true
      this.$socket.emit('medical', this.form.name, m => {
        this.extend.medical = m
        this.medicalLoading = false
      })
    },
    check_in(student) {
      console.log(`student ->`, student)
      if (student.name === '') return this.$message.error("You can't set student name!")

      let t = new Date().getHours()
      if (t >= 10 && !confirm(`Are you sure that you want to check in?`)) return

      student.loading = true
      // let data = JSON.parse(JSON.stringify(student))
      // data.code = ''
      // data.parent = student.parents
      // data.check = 'in'
      let data = {
        name: student.name,
        parent: student.parent,
        code: '',
        course: student.course,
        teacher: this.$store.state.user.info.name,
        temperature: '',
        check: 'in',
        commits: student.commits
      }
      if (typeof data.name === 'object') {
        data.name = data.name[0]
      }
      console.log(data)
      this.$socket.emit('notice', data, (err, user) => {
        // student.check = 'in'
        student.loading = false
        // eslint-disable-next-line
        console.log(err, user)
        if (!err) {
          this.students.forEach(s => {
            console.log(`s.name ->`, s.name, user.name)
            if (s.name === user.name) {
              s.check = 'in'
              s.parents = s.parents.concat(s.parent).unique()
            }
          })

          // console.log(this.students)
        }
      })
    },
    cancel_check(student) {
      console.log(student)
      if (!confirm(`Are you sure that you want to check ${student.check}?`)) return
      this.$socket.emit('cancel', student)
      if (student.check === 'in') student.check = ''
      if (student.check === 'out') student.check = 'in'
    },
    check_out(s) {
      if (s.name === '') return this.$message.error("You can't set student name!")

      if (s.check !== 'in') return this.$message.error('This user not Check-In!')

      let t = new Date().getHours()
      if (t <= 14 && !confirm(`Are you sure that you want to check out?`)) return

      s.loading = true
      // let data = JSON.parse(JSON.stringify(s))
      let data = {
        name: s.name,
        parent: s.parent,
        code: '',
        course: s.course,
        teacher: this.$store.state.user.info.name,
        temperature: '',
        check: 'out',
        commits: s.commits
      }
      console.log(`data ->`, data)
      // data.check = 'out'
      if (typeof data.name === 'object') {
        data.name = data.name[0]
      }
      this.$socket.emit('notice', data, (err, user) => {
        s.loading = false
        // eslint-disable-next-line
        console.log(err, user)
        if (!err) {
          this.students.forEach(student => {
            if (student.name === user.name) {
              student.check = 'out'
              student.parents = student.parents.concat(student.parent).unique()
            }
          })
          // console.log(this.students)
        } else {
          // console.log(err)
          if (err.type && err.message) this.$message[err.type](err.message)
        }
      })
    },
    remoteMethod(query) {
      if (query !== '') {
        // this.loading = true
        // setTimeout(() => {
        //   this.loading = false
        this.student = this.students
          .filter(u => !u.check)
          .map(u => u.name)
          .filter(item => {
            return item.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
          .map(item => {
            return { value: item, label: item }
          })
          .sort(this.nameSort)
        // }, 200)
      } else {
        this.student = this.students
          .filter(u => !u.check)
          .map(u => u.name)
          .map(item => {
            return { value: item, label: item }
          })
          .sort(this.nameSort)
      }
      // eslint-disable-next-line
      console.log(this.student)
    },
    remoteMethodOut(query) {
      if (query !== '') {
        // this.loading = true
        // setTimeout(() => {
        //   this.loading = false
        this.studentOut = this.students
          .filter(u => u.check && u.check === 'in')
          .map(u => u.name)
          .filter(item => {
            return item.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
          .map(item => {
            return { value: item, label: item }
          })
          .sort(this.nameSort)
        // }, 200)
      } else {
        this.studentOut = this.students
          .filter(u => u.check && u.check === 'in')
          .map(u => u.name)
          .map(item => {
            return { value: item, label: item }
          })
          .sort(this.nameSort)
      }
      // console.log(this.student)
    },
    clickTags(tag) {
      const index = this.selectedTags.indexOf(tag)
      index !== -1 ? this.selectedTags.splice(index, 1) : this.selectedTags.push(tag)
    },
    handleSearch() {
      try {
        let searchR = new RegExp(this.search, 'gi')
        const tags = this.selectedTags.filter(x => typeof x === 'number').join('')
        const tagsReg = tags.length > 0 ? new RegExp(`^[a-z]+[0-9]{1}[${tags}]`, 'gi') : null
        this.studentsShow = this.students
          .filter(s => {
            let flag = 0
            if (this.selectedTags.indexOf('lunch') !== -1) {
              flag = 1
              if (s.lunch === 'yes') {
                return true
              }
            }
            if (this.selectedTags.indexOf('extend') !== -1) {
              flag = 1
              if (s.extend === 'yes') {
                return true
              }
            }
            if (this.selectedTags.indexOf('pc') !== -1) {
              flag = 1
              if (s.pc === 'yes') {
                return true
              }
            }
            return flag ? false : true
          })
          .filter(s => {
            if (tagsReg) {
              return s.course.search(tagsReg) !== -1
            } else {
              return true
            }
          })
          .filter(s => {
            return this.search
              ? s.name.search(searchR) !== -1 ||
                  s.course.search(searchR) !== -1 ||
                  s.parents.filter(p => p.search(searchR) !== -1).length > 0
              : true
          })
          .sort((a, b) => {
            let aa = a.name.substring(0, 1).charCodeAt(),
              bb = b.name.substring(0, 1).charCodeAt()
            // if (a.check === 'in' && now <= 12) aa = 1
            // if (a.check === 'out' && now > 12) aa = 1
            // if (b.check === 'in' && now <= 12) bb = 1
            // if (b.check === 'out' && now > 12) bb = 1
            return aa - bb
          })
      } catch (e) {
        console.log(e)
      }
    }
  },
  destroyed() {
    this.$socket = null
    // Vue.delete(this, 'socket');
    clearInterval(this.timer)
  }
}
</script>

<style scoped>
ul.list li {
  margin-bottom: 20px;
  border-bottom: #ccc solid 1px;
  padding-bottom: 20px;
}

.user {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
}

.user .name {
  width: 50%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: stretch;
  justify-content: space-between;
  align-items: flex-start;
}

.user .name div {
  width: 100%;
  text-overflow: ellipsis; /*让截断的文字显示为点点。还有一个值是clip意截断不显示点点*/
  white-space: nowrap; /*让文字不换行*/
  overflow: hidden; /*超出要隐藏*/
}

.user .name div:first-child {
  font-size: 14px;
}

.user .name div:last-child {
  display: flex;
}

.user .name .parent {
  color: #545454;
  font-size: 12px;
  margin-right: 5px;
}

.user .name .parent > i {
  font-size: 12px;
  color: #95c5ff;
}

.user > i.icon {
  text-align: center;
  width: 30px;
}

.user .course {
  width: 20%;
}

.expand {
  border-top: #ccc 1px dashed;
  margin-top: 10px;
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  align-items: flex-start;
}

.expand .bt {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-end;
  width: 40%;
  margin-left: 10px;
}

.expand .bt:first-child {
  align-items: flex-start;
  width: 60%;
  margin-left: 0;
}

.expand .bt button,
.expand .bt > div {
  width: 100%;
}

.expand .bt button:not(:last-child),
.expand .bt > div:not(:last-child) {
  margin-bottom: 10px;
}

.expand .bt .title {
  color: #ccc;
  font-size: 12px;
  margin-bottom: 5px !important;
  /*margin-top: 15px;*/
}

.el-tag {
  font-size: 9px;
}

h1 > a {
  font-size: 16px;
}

.el-tag {
  margin-right: 5px;
}

.el-select {
  width: 100%;
}

.hide {
  display: none;
}

.show {
  display: block;
}

@media (max-width: 700px) {
  .el-col.el-col-8 {
    width: 100%;
  }

  .hide {
    display: block;
  }

  .show {
    display: none;
  }

  .el-form-item {
    margin: 0;
  }

  .el-form--label-top .el-form-item__label {
    padding: 0;
  }

  .el-form-item__label {
    line-height: unset;
  }
}
</style>

<style>
.el-form--label-top .el-form-item__label {
  padding: 0 !important;
  margin-bottom: 0 !important;
}

.el-popover.el-popper {
  padding: 0 !important;
}

.akeyboard-keyboard-keys {
  width: 80px;
}

/*.el-input.is-disabled.temp .el-input__inner {*/
/*  cursor: default !important;*/
/*}*/

@media (max-width: 700px) {
  .el-form--label-top .el-form-item__label {
    padding: 0;
  }

  .el-form-item__label {
    line-height: unset;
  }
}
</style>
